export  class Helper{

  static centToEuro(cent: number): string {
    return (cent / 100).toFixed(2).replace(".", ",") + " €";
  }
}
